import _ from "lodash";
import React from "react";
import { format } from "date-fns";
import { Helmet } from "react-helmet";
import share from "~/tools/share";
import formatVideoDuration from "~/tools/formatVidDuration";
import { trackEvent } from "~/tools/analytics/cleverTap";
import Timer from "~/components/Timer";
import Overlay from "~/components/Overlay";
import { getUser } from "~/redux/user/helpers";
import popup from "~/views/Popup/popup";
import VideoJSPlayer from "~/components/VideoPlayer";
import SharePopup from "~/views/Share/events";
import { AddToWatchlistIcon, RemoveFromWatchlistIcon } from "~/assets/svg";
import { PlayCircleSvg } from "~/components/VideoPlayer/assets/icons";
import { 
  getVideoInfo, 
  addToQueue, 
  removeFromQueue, 
  playVideo, 
  getTransactionInfo 
} from '~/redux/uservideo/helpers'
import { onUserAuth } from '~/redux/user/helpers'
import connect from "~/tools/connect";
import userStore from '~/redux/user/store';

import "./style.css";

class VideoPlayerWithInfo02 extends React.Component {
  constructor(props) {
    super(props);

    this.data = props.data.contentData[0];
    this.settings = props.data.settings;

    this.state = {
      video: ((props.data || {}).contentData || [])[0],
      isQueued: false,
      pricingOptions: _.get(props.data, "contentData[0].pricing")
    };
  }

  componentDidMount() {
    onUserAuth(() => this.fetchVideoInfo());
    this.state.video.pricing && this.getTransactionInfo();
  }

  getTransactionInfo() {
    var { contentType, id } = this.state.video.gist;
    getUser(user => {
      if (!user) {
        this.setState({
          purchased: false
        });
        return;
      }
      if (
        user &&
        user.isSubscribed &&
        this.state.video.pricing.type &&
        this.state.video.pricing.type.includes("SVOD+")
      ) {
        this.setState({
          purchased: true
        });
        return;
      }
      getTransactionInfo(user.userId, false, contentType, id).then(res => {
        if (res.data && res.data[0][id]) {
          this.setState({
            purchased: true
          });
        } else {
          this.setState({ purchased: false });
        }
      });
    });
  }

  fetchVideoInfo() {
    var id = this.data.gist.id;
    getVideoInfo(id, data =>
      this.setState({ isQueued: data.isQueued, startTime: data.watchedTime })
    );
  }

  toggleQueue = () => {
    if (!this.state.user) popup.login();

    const { gist = {}, creditBlocks = [], categories = [] } = this.data;
    const id = gist.id;
    const contentType = gist.contentType;

    this.state.isQueued
      ? removeFromQueue(id, data => {
          categories.push(gist.primaryCategory);
          var removeFromQueueEventData = {
            contentId: gist.id,
            contentTitle: gist.title,
            contentType: gist.mediaType === "EPISODIC" ? "Episode" : "Video",
            contentDuration: gist.runtime,
            playbackType: "Streamed"
          };
          creditBlocks.forEach(creditBlock => {
            if (creditBlock.title.trim().toLowerCase() === "director") {
              removeFromQueueEventData.directorName =
                creditBlock.credits && creditBlock.credits.length > 0
                  ? creditBlock.credits.forEach(it => it.title).join(",")
                  : "";
            }
            if (creditBlock.title.trim().toLowerCase() === "starring") {
              removeFromQueueEventData.actorName =
                creditBlock.credits && creditBlock.credits.length > 0
                  ? creditBlock.credits.forEach(it => it.title).join(",")
                  : "";
            }
          });
          removeFromQueueEventData.contentGenre = categories
            .map(category => category && category.title)
            .join(",");
          trackEvent("Removed From Watchlist", removeFromQueueEventData);
          this.setState({ isQueued: false });
        })
      : addToQueue(id, contentType, data => {
          categories.push(gist.primaryCategory);
          var addToQueueEventData = {
            contentId: gist.id,
            contentTitle: gist.title,
            contentType: gist.mediaType === "EPISODIC" ? "Episode" : "Video",
            contentDuration: gist.runtime,
            playbackType: "Streamed"
          };
          creditBlocks.forEach(creditBlock => {
            if (creditBlock.title.trim().toLowerCase() === "director") {
              addToQueueEventData.directorName =
                creditBlock.credits && creditBlock.credits.length > 0
                  ? creditBlock.credits.forEach(it => it.title).join(",")
                  : "";
            }
            if (creditBlock.title.trim().toLowerCase() === "starring") {
              addToQueueEventData.actorName =
                creditBlock.credits && creditBlock.credits.length > 0
                  ? creditBlock.credits.forEach(it => it.title).join(",")
                  : "";
            }
          });
          addToQueueEventData.contentGenre = categories
            .map(category => category && category.title)
            .join(",");
          trackEvent("Added to Watchlist", addToQueueEventData);
          console.log('here')
          this.setState({ isQueued: true });
        });
  };

  handleShareToggleClick = event => {
    event.preventDefault();
    const shareOptions = {
      position: event.currentTarget.getBoundingClientRect(),
      data: this.data.gist
    };
    SharePopup.open(shareOptions);
  };
  renderHelmet = () => {
    const { gist } = this.data;
    return (
      <Helmet>
        <title>{`${gist.title} | ${window.settings.site}`}</title>
        <meta name="description" content={gist.description} />

        <meta property="og:type" content="video.movie" />
        <meta property="og:title" content={gist.title} />
        <meta property="og:description" content={gist.description} />
        <meta
          property="og:image"
          content={gist.posterImageUrl || gist.videoImageUrl}
        />
      </Helmet>
    );
  };
  socialShare(platform) {
    const { gist = {}, creditBlocks = [], categories = [] } = this.state.video;
    categories.push(gist.primaryCategory);
    var videoEventData = {
      contentId: gist.id,
      contentTitle: gist.title,
      contentType: gist.isTrailer
        ? "Trailer"
        : gist.mediaType === "EPISODIC"
        ? "Episode"
        : "Movie Video",
      contentDuration: gist.runtime,
      playbackType: "Streamed"
    };
    creditBlocks.forEach(creditBlock => {
      if (creditBlock.title.trim().toLowerCase() === "director") {
        videoEventData.directorName =
          creditBlock.credits && creditBlock.credits.length > 0
            ? creditBlock.credits.map(it => it && it.title).join(",")
            : "";
      }
      if (creditBlock.title.trim().toLowerCase() === "starring") {
        videoEventData.actorName =
          creditBlock.credits && creditBlock.credits.length > 0
            ? creditBlock.credits.map(it => it && it.title).join(",")
            : "";
      }
    });
    videoEventData.contentGenre = categories
      .map(category => category && category.title)
      .join(",");
    videoEventData.medium = platform;
    switch (platform) {
      case "Facebook":
        share.facebook(window.location.href);
        break;
      case "Twitter":
        share.twitter(window.location.href, gist.title);
        break;
      case "Email":
        share.email(window.location.href);
        break;
      default:
        break;
    }
    trackEvent("Shared", videoEventData);
  }
  renderPurchaseOptions(video, purchased, showPlayButton, showSubscribeOption) {
    const background = {
      backgroundImage: `url(${video.gist.videoImageUrl})`,
      backgroundPosition: "center",
      backgroundSize: "cover"
    };
    const isSubscribed = this.state.user && this.state.user.isSubscribed
    const hasNotPurchased = this.state.purchased !== undefined && !purchased
    return (
      <div style={{ position: "relative", background: "#100101" }}>
        {video &&
          video.gist.scheduleStartDate &&
          video.gist.scheduleStartDate - Date.now() > 0 && (
            <Timer
              header="Time until this video is available!"
              startTime={video.gist.scheduleStartDate}
              hide={() => this.setState({ startPlaying: true })}
            />
          )}
        { (video.pricing.type === 'SVOD' ? !isSubscribed : hasNotPurchased) && (
          <div
            className={`transaction-options ${!showSubscribeOption &&
              "subscriptions"}`}
          >
            <Overlay
              content={this.state.video}
              watchNow={() => {
                popup.hide();
                this.setState({ watchNow: true });
                playVideo(this.state.user.userId, video.gist.id);
              }}
              purchased={() => this.setState({ purchased: true })}
            />
          </div>
        )}
        <div
          className="video-player-bg"
          style={background}
        >
          { showPlayButton && (
            <div
              className="play-icon-overlay"
              onClick={() => {
                playVideo(this.state.user.userId, video.gist.id);
                this.setState({ watchNow: true });
              }}
            >
              <PlayCircleSvg />
            </div>
          )}
          {video.gist.scheduleStartDate &&
            video.gist.scheduleStartDate - Date.now() > 0 &&
            purchased &&
            this.state.user && (
              <div className="purchased-copy">
                <p>You have purchased this video</p>
                <p>Sit back, and enjoy when it starts</p>
              </div>
            )}
        </div>
      </div>
    );
  }
  render() {
    const { gist, contentDetails, parentalRating } = this.data;
    const fileType = this.props.layout.settings.fileType;
    const startTime = this.state.startTime;
    const previewSettings = window.settings.features.free_preview;
    const showPreview = previewSettings && previewSettings.isFreePreview;
    const previewshowUnit = previewSettings && previewSettings.length.unit;
    const status = _.get(
      this.state.user,
      "subscription.subscriptionInfo.subscriptionStatus"
    );
    if (status === "INACTIVE") {
      window.sessionStorage.setItem("openUpdatecard", true);
    }
    const video = this.state.video;
    const isFutureStartDate =
      video.gist.scheduleStartDate &&
      video.gist.scheduleStartDate - Date.now() > 0;
    const isSubscribed = this.state.user && this.state.user.isSubscribed 
    const isOfType = (type) => video && video.pricing && (video.pricing.type && video.pricing.type.includes(type))
    const showSubscribeOption =
      isSubscribed &&
      isOfType('SVOD+') &&
      !isFutureStartDate;
    const purchased = this.state.user && this.state.purchased;
    const watchNow = this.state.user && this.state.watchNow;
    let showPlayButton;
    if (purchased) {
      showPlayButton = true;
    }
    if (isFutureStartDate) {
      showPlayButton = false;
    }
    const previewShowTime =
      previewshowUnit === "Minutes"
        ? parseInt(previewSettings.length.multiplier, 10) * 60
        : parseInt(previewSettings.length.multiplier, 10);
    const categoryTitle = _.get(gist.primaryCategory, "title", "");
    return (
      <div className="video-player-with-info-02">
        {this.renderHelmet()}
        {video &&
        !video.gist.free &&
        video.pricing &&
        (
          (video.pricing.rent || video.pricing.purchase) || 
          (isFutureStartDate && isOfType('SVOD'))
        ) &&
        !showSubscribeOption &&
        !watchNow ? (
          <div className="video-module-wrapper">
            {this.renderPurchaseOptions(
              video,
              purchased,
              showPlayButton,
              showSubscribeOption
            )}
          </div>
        ) : (
          <div className="videojs-player-container">
            <VideoJSPlayer
              {...this.state}
              videoId={gist.id}
              category={categoryTitle}
              fileType={fileType}
              isTrailer={false}
              autoplay={true}
              permalink={gist.permalink}
              previewTime={showPreview && previewShowTime}
              videoTag={_.get(window.settings, "advertising.videoTag")}
              parentalRating={parentalRating}
              isFree={gist.free}
              startTime={startTime}
              closedCaptions={contentDetails.closedCaptions}
            />
          </div>
        )}
        <div className="border-top site-color" />
        <div className="video-info">
          <div className="info">
            <div className="title">{gist.title}</div>
            {!_.get(this.data, "streamingInfo.isLiveStream") && (
              <div className="production-details">
                <span className="runtime">
                  {formatVideoDuration(gist.runtime)}
                </span>
                {gist.publishDate && (
                  <span className="publish-date">
                    Published on {format(gist.publishDate, "MMMM D[,] YYYY")}
                  </span>
                )}
              </div>
            )}
            <div className="description">{gist.description}</div>
          </div>
          <div className="share-options">
            <div className="add-watchlist" onClick={this.toggleQueue}>
              <button className="cta">
                {this.state.isQueued && this.state.user
                  ? "Remove from "
                  : "Add to "}{" "}
                watchlist
              </button>
              {this.state.isQueued && this.state.user ? (
                <RemoveFromWatchlistIcon className="site-color" />
              ) : (
                <AddToWatchlistIcon className="site-color" />
              )}
            </div>
            <i
              className="ion-social-facebook"
              onClick={() => {
                this.socialShare("Facebook");
              }}
            />
            <i
              className="ion-social-twitter"
              onClick={() => {
                this.socialShare("Twitter");
              }}
            />
          </div>
          <div className="mobile-share share">
            <div
              className="share-toggle__icon"
              onClick={this.handleShareToggleClick}
            >
              <span className="small-rect" />
              <span className="small-rect" />
              <span className="small-rect" />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

connect(VideoPlayerWithInfo02, state => ({ user: state.user }), userStore)
export default VideoPlayerWithInfo02;

